export function newRelic(statusCode = null, message, svocid = null) {
  if (typeof window.newrelic !== 'undefined'
    && typeof window.newrelic.addPageAction === 'function') {
    window.newrelic.addPageAction('THD Credit Card Experience', {
      statusCode: statusCode && statusCode.toString(),
      message,
      svocId: svocid && svocid.toString()
    });
  }
}

export function logAccountSnapshot(data) {
  if (data.plcn_sso) {
    newRelic(200, 'Consumer Account Snapshot');
  }
  if (data.plcr_sso) {
    newRelic(200, 'CRC Account Snapshot');
  }
  if (data.plnp_sso) {
    newRelic(200, 'PROX Account Snapshot');
  }
}
